var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgModule = (_ref, ref) => {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 60 60",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    fill: "transparent",
    d: "m30 0c-16.542 0-30 13.458-30 30s13.458 30 30 30 30-13.458 30-30-13.458-30-30-30zm0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    fill: "transparent",
    d: "m39 20c3.309 0 6-2.691 6-6s-2.691-6-6-6c-3.131 0-5.705 2.411-5.973 5.474l-14.066 10.314c-0.875-0.499-1.884-0.788-2.961-0.788-3.309 0-6 2.691-6 6s2.691 6 6 6c1.077 0 2.086-0.289 2.961-0.788l14.065 10.314c0.269 3.063 2.843 5.474 5.974 5.474 3.309 0 6-2.691 6-6s-2.691-6-6-6c-2.69 0-4.972 1.78-5.731 4.223l-12.716-9.325c0.899-1.05 1.447-2.41 1.447-3.898s-0.548-2.848-1.448-3.898l12.716-9.325c0.76 2.443 3.042 4.223 5.732 4.223zm0-10c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm-27 19c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.794-4-4zm27 11c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgModule);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/module.b72adc19db5c36d87a919811a441bf6c.svg";